module.exports = __webpack_public_path__ + "static/media/Slide7.c1a7d2ed.png";